import "./Sidebar.scss";
import React, { useEffect } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCashRegister, faGear, faIgloo, faMountainCity, faUsers} from "@fortawesome/free-solid-svg-icons";
import {useLocation, Link, useNavigate} from "react-router-dom";

function Sidebar({ user, isMobileMenuOpen, onClose }) {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    const isActive = (path) => {
        return currentPath.includes(path);
    };

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && !event.target.closest('.navbar-left')) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen, onClose]);

    // Close mobile menu on route change
    useEffect(() => {
        onClose();
        // eslint-disable-next-line
    }, [location.pathname]);

    const sidebarItems = [
        {label: "Dashboard", icon: faIgloo, path: "/app/dashboard",},
        {label: "Applications", icon: faMountainCity, path: "/app/applications",},
        {label: "Users", icon: faUsers, path: "/app/users",},
        {label: "Plans", icon: faCashRegister, path: "/app/plans",},
        {label: "Settings", icon: faGear, path: "/app/settings",},
    ];

    return (
        <>
            <div 
                className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={onClose}
                aria-hidden={!isMobileMenuOpen}
            />
            <div 
                className={`navbar-left ${isMobileMenuOpen ? 'mobile-open' : ''}`}
                role="navigation"
                aria-label="Main navigation"
            >
                <header>
                    <h1>mobiyo</h1>
                </header>
                <nav>
                    <ul>
                        {
                            sidebarItems.map((item, index) => (
                                <li key={index} className={isActive(item.path) ? 'current-page' : ''}>
                                    <Link 
                                        to={item.path}
                                        onClick={() => { onClose(); }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={item.icon}/>
                                        {item.label}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                </nav>
            </div>
        </>
    );
}

export {Sidebar};
